import { render, staticRenderFns } from "./KaoguanList.vue?vue&type=template&id=cd56f7f0&scoped=true&"
import script from "./KaoguanList.vue?vue&type=script&lang=js&"
export * from "./KaoguanList.vue?vue&type=script&lang=js&"
import style0 from "./KaoguanList.vue?vue&type=style&index=0&id=cd56f7f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd56f7f0",
  null
  
)

export default component.exports